"use client";

import { i, init } from "@instantdb/react";

const APP_ID = import.meta.env.VITE_INSTANTDB_APP_ID;

const schema = i.schema({
    entities: {
        $users: i.entity({
            email: i.any().unique().indexed(),
        }),
        messages: i.entity({
            content: i.string(),
            messageType: i.string(),
            meta: i.json().optional(),
            sender: i.string(),
            senderType: i.string(),
            roomId: i.string().indexed(),
            isRead: i.boolean(),
            isDelivered: i.boolean(),
            isSaved: i.boolean(),
            isDeleted: i.boolean(),
            isEdited: i.boolean(),
            createdAt: i.date().indexed(),
            editedAt: i.date(),
            updatedAt: i.date(),
            deletedAt: i.date(),
        }),
        rooms: i.entity({
            name: i.string().indexed(),
            entityId: i.string(),
            status: i.string(),
            customer: i.string(),
            type: i.string(),
            isAnonymous: i.boolean(),
            lastActive: i.date().indexed(),
            createdAt: i.date(),
            updatedAt: i.date(),
        }),
        users: i.entity({
            userId: i.string(),
            email: i.string(),
            role: i.string(),
            firstName: i.string(),
            lastName: i.string(),
            photoUrl: i.string().optional(),
        }),
    },
    links: {
        msg: {
            forward: { on: "messages", has: "one", label: "room" },
            reverse: { on: "rooms", has: "many", label: "msgs" },
        },
        profile: {
            forward: { on: "rooms", has: "one", label: "user" },
            reverse: { on: "users", has: "many", label: "room" },
        },
        userProfiles: {
            forward: { on: 'users', has: 'one', label: 'account' },
            reverse: { on: '$users', has: 'one', label: 'profile' },
        },
    }
});

export default schema;

export const InstantDb = init({ appId: APP_ID, schema, devtool: false });